import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axiosInstance from '../axiosInstance';
import { getCurrentUser as getCurrentUserAdmin } from "../components/Admin/services/authService";
import { APPROVAL_TYPE_CODES, getApprovalActionByCode } from "../constants/approvalTypes";

export const useFormActions = () => {
  const navigate = useNavigate();

  const handleAction = async ({ child, requestProgressId, prevComments, rejectionReason, certificateFileId, certificateLicenseNumber }) => {
    console.log("[useFormActions] handleAction called with:", { 
      action: child.ApprovalType?.code, 
      requestProgressId 
    });

    // Validate comments for sendback action
    if (child.ApprovalType?.code === APPROVAL_TYPE_CODES.SENDBACK) {
      // Filter comments for current request to check if any exist
      const hasComments = prevComments && prevComments.length > 0;
      if (!hasComments) {
        toast.warning("Please add at least one comment before sending back.", {
          position: "top-center",
        });
        return;
      }
    }

    try {
      // If this is a rejection action, first create a committee review entry
      if (child.ApprovalType?.code === APPROVAL_TYPE_CODES.REJECTED && rejectionReason) {
        try {
          // Only PI/admin users use this hook
          const user = await getCurrentUserAdmin();
          
          if (user) {
            const reviewBody = {
              review: "rejected",
              request_progress_id: +requestProgressId,
              rejection_reason: rejectionReason
            };
            
            // Create committee review entry using admin endpoint
            await axiosInstance.post("/api/committee-reviews", reviewBody);
          }
        } catch (reviewError) {
          console.error("Error creating committee review:", reviewError);
          // stop workflow
          return;
        }
      }

      // Now proceed with the workflow switch
      const requestBody = {
        action: getApprovalActionByCode(child.ApprovalType?.code),
        actionStageId: child.id,
        requestsProgressId: requestProgressId,
        wf_version_id: child.wf_version_id,
      };

      // Add rejection reason if action is rejected
      if (child.ApprovalType?.code === APPROVAL_TYPE_CODES.REJECTED && rejectionReason) {
        requestBody.rejectionReason = rejectionReason;
      }

      // Add certificate file ID and license number if provided (for RA final approval)
      if (certificateFileId) {
        requestBody.certificateFileId = certificateFileId;
      }
      if (certificateLicenseNumber) {
        requestBody.certificateLicenseNumber = certificateLicenseNumber;
      }

      console.log("[useFormActions] Submitting action to API:", requestBody);
      const response = await axiosInstance.post("/api/requests-progress/switch", requestBody);
      console.log("[useFormActions] API response:", response.data);

      toast.success("Review Submitted Successfully", {
        position: "top-center",
      });
      
      console.log("[useFormActions] Navigating back...");
      navigate(-1);
      console.log("[useFormActions] Navigate called");
    } catch (error) {
      console.error("[useFormActions] Error submitting action:", error);
      console.error("[useFormActions] Error details:", error.response?.data);
      toast.error(error.response?.data?.message || "Error submitting review", {
        position: "top-center",
      });
    }
  };

  return {
    handleAction,
  };
}; 